import React, {useEffect, useRef, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom'; // Logic Added
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Accordion from 'react-bootstrap/Accordion';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import {Chart} from "react-google-charts";
import axios from 'axios';
import errorMessages from '../errorMessages.js';
import {showToast as toast} from '../toastManager';
import {verifySdkPopup, describeVerifyFailure} from '../utils/verifySdkPopup';
import ReMultiSelect from 'react-select';
import ReMultiSelectAnimated from 'react-select/animated';
// import errorMessages from '../errorMessages.js';
import {v4 as uuidv4} from 'uuid';
import Label from 'react-bootstrap/FormLabel';
import Breadcrumbs from '../components/Breadcrumbs';
import '../ChatApp.css';
import '../Opportunites.css';

const FRONTEND_ENVIRONMENT = process.env.REACT_APP_VISUAL_EDITOR_ENV || 'dev';

// Snapshot of the campaign fields the Save button persists, used to keep Save
// disabled until something actually changes. targeting_and_content is
// intentionally excluded — variant delete auto-persists to /api/cux/delete-variant.
const campaignSnapshot = (cd) => JSON.stringify({
    campaign_name:     cd?.campaign_name ?? '',
    status:            cd?.status ?? '',
    sdk_verified:      !!cd?.sdk_verified,
    landing_page_urls: cd?.landing_page_urls ?? '',
    templates:         cd?.templates ?? null,
});


const getCampaignsFromStorage = () => {
    const storedCampaigns = sessionStorage.getItem('campaigns');
    if (storedCampaigns) {
        try {
            const parsed = JSON.parse(storedCampaigns);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            console.error("Failed to parse campaigns from sessionStorage:", e);
            return [];
        }
    }
    return [];
};

const saveCampaignsToStorage = (campaigns) => {
    try {

        const validCampaigns = campaigns.filter(c => c && c.campaign_id);
        sessionStorage.setItem('campaigns', JSON.stringify(validCampaigns));
    } catch (e) {
        console.error("Failed to save campaigns to sessionStorage:", e);
        toast.error("Could not save campaign changes.");
    }
};


const PersonalizationCampaign = ({ViewedPage, shop_domain, app_url}) => {
    ViewedPage(28);
    const location = useLocation();
    const navigate = useNavigate();

    const initialallTargeting = location.state?.allTargeting;
    const initialCampaignData = location.state?.campaignData;
    console.log("initialCampaignData", initialCampaignData)
    const previousPage = location.state?.previousPage || 'campaign-summary'; // Track where we came from

    const [loading, setLoading] = useState(true);
    const [select_template_button_loading, setSelectTemplateButtonLoading] = useState(false);
    const [select_landing_page_button_loading, setSelectLandingPageButtonLoading] = useState(false);
    const [publish_btn_loading, setPublishBtnLoading] = useState(false);
    const [campaignData, setCampaignData] = useState(null);
    const [isEditingName, setIsEditingName] = useState(false);
    const campaignNameInputRef = useRef(null);
    const [sdkClientKey, setSdkClientKey] = useState(null);
    // SDK verification status — not a gate, just a non-blocking signal we
    // surface in a banner inside the landing-page accordion. Values:
    //   'idle'      → never verified (banner: prompt to verify)
    //   'verifying' → popup is open (banner: spinner)
    //   'verified'  → SDK confirmed on the page (banner hidden)
    //   'failed'    → last attempt failed (banner: error + retry)
    const [sdkVerifyState, setSdkVerifyState] = useState('idle');
    const [sdkVerifyError, setSdkVerifyError] = useState(null);
    // Collapsed by default — the "not verified" notice shows only a small heading
    // until the user expands it (auto-expands after a failed verify attempt).
    const [sdkNoticeOpen, setSdkNoticeOpen] = useState(false);
    // Baseline snapshot of the loaded campaign — Save stays disabled until
    // campaignSnapshot(campaignData) differs from this.
    const initialSnapshotRef = useRef(null);
    // New state: track if template has been selected
    const [templateSelected, setTemplateSelected] = useState(false);
    // New state: track if landing page has been selected
    const [landingPageSelected, setLandingPageSelected] = useState(false);
    const [landingPageValidationError, setLandingPageValidationError] = useState('');
    const [templatePreview, setTemplatePreview] = useState(null);
    const [templateRefreshLoading, setTemplateRefreshLoading] = useState(false);
    const [templatePolling, setTemplatePolling] = useState(false);
    const templatePollIntervalRef = useRef(null);
    const templatePollTimeoutRef = useRef(null);
    const [activeAccordionKeys, setActiveAccordionKeys] = useState([]);
    const [targetingSearch, setTargetingSearch] = useState('');
    const lockedAccordionStyle = {
        pointerEvents: 'none',
        userSelect: 'none',
        opacity: 1
    };

    const TARGETING_CONTENT_PAGE_SIZE = 3;
    const [targetingContentTablePage, setTargetingContentTablePage] = useState(1);

    const pollTemplateOnce = async () => {
        if (!campaignData?.campaign_id) return false;
        try {
            const response = await axios.get(`${app_url}/api/store/personalized_campaigns/${campaignData.campaign_id}/template/poll`, {
                withCredentials: true,
                params: {
                    landing_page_url: campaignData?.landing_page_urls
                }
            });
            if (response?.data?.success && response?.data?.data) {
                applyTemplateUpdate(response.data.data, { showToast: false });
                toast.success('Template updated from Visual Editor.');
                return true;
            }
        } catch (error) {
            console.error('Polling template failed', error);
        }
        return false;
    };

    const startTemplatePolling = () => {
        if (templatePolling || !campaignData?.campaign_id) return;
        clearTemplatePolling(true);
        setTemplatePolling(true);
        // Interval: every 3s, Timeout: 90s
        templatePollIntervalRef.current = setInterval(async () => {
            const done = await pollTemplateOnce();
            if (done) {
                clearTemplatePolling();
            }
        }, 3000);
        templatePollTimeoutRef.current = setTimeout(() => {
            clearTemplatePolling();
            setTemplatePolling(false);
            toast.error('Template update timed out. You can still use Refresh Template.');
        }, 90000);
    };

    const LockedHeader = ({label, locked, reason, additionalContent=null}) => (
        <span className={locked ? '' : ''}>{label} {additionalContent && <><br /><i style={{fontSize: '10px'}}>{additionalContent}</i></>}</span>
    );

    const AccordionLockIcon = ({reason}) => (
        <span title={reason} className="d-inline-flex align-items-center" style={{fontSize: '0.9rem'}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="black" className="bi bi-lock-fill" viewBox="0 0 16 16">
                <path d="M8 1a3 3 0 0 0-3 3v3h6V4a3 3 0 0 0-3-3zm4 6H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z"/>
            </svg>
        </span>
    );

    const normalizeTemplatePayload = (templatePayload) => {
        if (!templatePayload) return null;
        if (Array.isArray(templatePayload)) {
            return templatePayload[0] || null;
        }
        if (templatePayload.value && typeof templatePayload.value === 'object') {
            return templatePayload.value;
        }
        return templatePayload;
    };

    const getCustomizedSections = (templatePayload) => {
        const normalized = templatePayload?.customized_sections;
        return Array.isArray(normalized) ? normalized : [];
    };

    const isTemplatePayloadLocked = (templatePayload) => {
        if (!templatePayload) return false;
        if (templatePayload?.locked === true) return true;
        if (templatePayload?.value && typeof templatePayload.value === 'object' && templatePayload.value.locked === true) {
            return true;
        }

        const normalized = normalizeTemplatePayload(templatePayload);
        return Boolean(normalized && typeof normalized === 'object' && normalized.locked === true);
    };


    const clearTemplatePolling = (silent = false) => {
        if (templatePollIntervalRef.current) {
            clearInterval(templatePollIntervalRef.current);
            templatePollIntervalRef.current = null;
        }
        if (templatePollTimeoutRef.current) {
            clearTimeout(templatePollTimeoutRef.current);
            templatePollTimeoutRef.current = null;
        }
        if (!silent) {
            setTemplatePolling(false);
        }
    };

    
    // Logic Added: Status options
    const statusOptions = [
        {value: 'draft', label: 'Draft'},
        {value: 'live', label: 'Live'}
    ];

    const [status, setStatus] = useState({
        value: 'draft',
        label: 'Draft'
    });
    const dropdownStyles = {
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menu: (provided) => ({ ...provided, zIndex: 9999 })
    };
    const statusDropdownStyles = {
        ...dropdownStyles,
        control: (provided) => ({
            ...provided,
            minHeight: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            paddingTop: '0px',
            paddingBottom: '0px',
            paddingRight: '0px',
            marginTop: '0px',
            marginBottom: '0px',
            borderRadius: '100px'
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '24px',
            paddingTop: '0px',
            paddingBottom: '0px',
            paddingLeft: '10px',
            paddingRight: '0px',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            lineHeight: '24px'
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '24px',
            paddingTop: '0px',
            paddingBottom: '0px',
            display: 'flex',
            alignItems: 'center'
        }),
        singleValue: (provided) => ({
            ...provided,
            margin: '-5px 0px 0px 0px',
            display: 'flex',
            alignItems: 'center',
            lineHeight: '24px',
            fontSize: '14px',
            height: '100%',
            padding: 0
        }),
        indicatorSeparator: () => ({
            display: 'none'
        })
    };


    const applyTemplateUpdate = (refreshedCampaign, { showToast = true } = {}) => {
        const refreshedTemplate = normalizeTemplatePayload(refreshedCampaign?.templates);
        if (refreshedTemplate) {
            setTemplatePreview(refreshedTemplate);
            setTemplateSelected(false);
            setCampaignData({...refreshedCampaign, status: status.value || refreshedCampaign.status});
            if (showToast) {
                toast.success('Template refreshed. Review the updates below.');
            }
        } else if (showToast) {
            toast.error('No template data available yet. Try launching the editor first.');
        }
    };

    const canLaunchVisualEditor = Boolean(
        landingPageSelected &&
        campaignData?.landing_page_urls &&
        campaignData.landing_page_urls.trim()
    );

    const templateAccordionLocked = isTemplatePayloadLocked(campaignData?.templates);

    useEffect(() => {
        console.log("PersonalizationCampaign received initial data:", initialCampaignData);
        if (initialCampaignData) {
            const ensuredId = initialCampaignData.campaign_id || uuidv4();

            const dataToSet = {
                ...initialCampaignData,
                campaign_id: ensuredId,
                campaign_name: initialCampaignData.campaign_name || 'Untitled Campaign',
                status: initialCampaignData.status || 'draft',
                category: initialCampaignData.category || 'Uncategorized',
                landing_page_urls: initialCampaignData.landing_page_urls || "",
                templates: initialCampaignData.templates || {},
                sections_rearrangement: initialCampaignData.sections_rearrangement || [],
                targeting_and_content: (initialCampaignData.targeting_and_content || []).map(item => ({
                    ...item,
                    id: item.id || uuidv4(),
                    lpPreview: item.lpPreview || item.preview_url || ''
                }))
            };
            console.log("Setting campaign data state:", dataToSet);
            setCampaignData(dataToSet);
            // Baseline for the dirty-check that gates the Save button.
            initialSnapshotRef.current = campaignSnapshot(dataToSet);
            // Restore a previously verified SDK status so the notice stays hidden.
            if (dataToSet.sdk_verified) setSdkVerifyState('verified');
            const savedStatus = (dataToSet.status || 'draft').toLowerCase();
            setStatus({
                value: savedStatus,
                label: savedStatus.charAt(0).toUpperCase() + savedStatus.slice(1)
            });
            if (dataToSet.templates) {
                setTemplatePreview(normalizeTemplatePayload(dataToSet.templates));
            }

            const hasTemplateLock = isTemplatePayloadLocked(dataToSet.templates);
            // If landing page and templates are already set in initial data, mark template as selected (lock fields)
            if (dataToSet.landing_page_urls && dataToSet.landing_page_urls.trim() &&
                dataToSet.templates && Object.keys(dataToSet.templates).length > 0) {
                setTemplateSelected(true);
                setLandingPageSelected(true);
            }
            if (hasTemplateLock) {
                setTemplateSelected(true);
            }

            setLoading(false);
        } else {
            navigate('/campaign-summary');
        }
    }, [initialCampaignData, navigate]);

    // Keep accordions closed for locked sections
    useEffect(() => {
        setActiveAccordionKeys((prev) => {
            let next = prev;
            if (landingPageSelected) {
                next = next.filter(key => key !== "0");
            }
            if (templateAccordionLocked) {
                next = next.filter(key => key !== "1");
            }
            return next;
        });
    }, [landingPageSelected, templateAccordionLocked]);

    const handleCampaignNameEdit = () => {
        setIsEditingName(true);
        setTimeout(() => {
            campaignNameInputRef.current?.focus();
        }, 0);
    };

    const handleCampaignNameChange = (e) => {
        setCampaignData(prev => ({...prev, campaign_name: e.target.value}));
    };

    const handleCampaignNameBlur = () => {
        setIsEditingName(false);
        if (!campaignData?.campaign_name?.trim()) {
            setCampaignData(prev => ({...prev, campaign_name: 'Untitled Campaign'}));
        }
        saveData();
    };

    const handleCampaignNameKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleCampaignNameBlur();
        }
    };

    const getSdkClientKey = async () => {
        if (sdkClientKey) {
            return sdkClientKey;
        }

        try {
            const response = await axios.post(`${app_url}/api/cux/connection-sdk-script`, {
                language: 'html'
            }, {withCredentials: true});

            if (response?.data?.clientKey) {
                setSdkClientKey(response.data.clientKey);
                return response.data.clientKey;
            }

            toast.error('Unable to fetch SDK client key.');
            return null;
        } catch (error) {
            console.error('Error fetching SDK client key:', error);
            toast.error('Failed to fetch SDK client key.');
            return null;
        }
    };

    // Triggered by the "Verify connection" button in the in-accordion
    // banner. Non-blocking: state updates drive the banner UI, but the
    // rest of the campaign flow runs regardless of result.
    const handleSdkVerifyClick = async () => {
        const url = campaignData?.landing_page_urls?.trim();
        if (!url) {
            toast.error('Please add a landing page URL first.');
            return;
        }
        if (sdkVerifyState === 'verifying') return;

        setSdkVerifyState('verifying');
        setSdkVerifyError(null);

        const clientKey = await getSdkClientKey();
        if (!clientKey) {
            setSdkVerifyState('failed');
            setSdkVerifyError('Could not fetch SDK client key.');
            return;
        }

        let startData;
        try {
            const startResponse = await axios.post(`${app_url}/api/store/check-sdk-script`, {
                url,
                clientKey
            }, {withCredentials: true});
            startData = startResponse?.data;
        } catch (error) {
            console.error('Error starting SDK verification:', error);
            setSdkVerifyState('failed');
            setSdkVerifyError('Could not start verification. Please try again.');
            return;
        }

        if (!startData || startData.mode !== 'popup' || !startData.popupUrl || !startData.pollUrl) {
            setSdkVerifyState('failed');
            setSdkVerifyError(startData?.message || 'Could not start SDK verification.');
            return;
        }

        if (toast.info) toast.info('Opening your landing page in a new tab to verify the SDK…');

        const result = await verifySdkPopup({
            popupUrl: startData.popupUrl,
            pollUrl: startData.pollUrl,
            token: startData.token,
            expiresInMs: startData.expiresInMs
        });

        if (result.ok && result.inHead) {
            setSdkVerifyState('verified');
            setSdkVerifyError(null);
            // Persist the verified status on the campaign so we don't prompt again —
            // rides in campaignData to sessionStorage now and to the server on publish.
            setCampaignData(prev => {
                const updated = { ...prev, sdk_verified: true, sdk_verified_at: new Date().toISOString() };
                saveData(null, updated);
                return updated;
            });
            return;
        }
        if (result.ok && !result.inHead) {
            setSdkVerifyState('failed');
            setSdkVerifyError('SDK is loaded but not inside the <head> tag. Please move the script tag into <head>.');
            setSdkNoticeOpen(true);
            return;
        }
        setSdkVerifyState('failed');
        setSdkVerifyError(describeVerifyFailure(result));
        setSdkNoticeOpen(true);
    };

    const base64UrlEncode = (input) => {
        try {
            const base64 = window.btoa(unescape(encodeURIComponent(input)));
            return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        } catch (error) {
            console.error('Error encoding launch payload:', error);
            return null;
        }
    };

    const buildLaunchEditorToken = () => {
        if (!campaignData?.landing_page_urls) {
            return null;
        }

        const resolvedTemplate = templatePreview || normalizeTemplatePayload(campaignData?.templates);
        const templateName = resolvedTemplate?.name || resolvedTemplate?.label || resolvedTemplate?.value?.name || '';
        const payload = {
            client_name: shop_domain?.replace(".myshopify.com", "") || shop_domain || '',
            environment: FRONTEND_ENVIRONMENT,
            template_name: templateName,
            landing_page_url: campaignData.landing_page_urls.trim(),
            campaign_id: campaignData?.campaign_id || uuidv4(),
            campaign_name: campaignData?.campaign_name || 'Untitled Campaign',
            category: campaignData?.category || 'Uncategorized'
        };

        return base64UrlEncode(JSON.stringify(payload));
    };

    const handleLaunchVisualEditor = () => {
        if (!landingPageSelected || !campaignData?.landing_page_urls || !campaignData.landing_page_urls.trim()) {
            toast.error('Please select a landing page first.');
            return;
        }

        const token = buildLaunchEditorToken();
        if (!token) {
            toast.error('Failed to build launch payload.');
            return;
        }

        try {
            const launchUrl = new URL(campaignData.landing_page_urls.trim());
            launchUrl.searchParams.set('sxi_auth_token', token);
            window.open(launchUrl.toString(), '_blank', 'noopener,noreferrer');
            startTemplatePolling();
        } catch (error) {
            console.error('Error launching Visual Editor:', error);
            toast.error('Invalid landing page URL.');
        }
    };

    const validateLandingPageUrl = (value) => {
        if (!value || !value.trim()) {
            return '';
        }

        try {
            const parsed = new URL(value.trim());
            if (!['http:', 'https:'].includes(parsed.protocol)) {
                return 'Enter a valid URL that starts with http or https.';
            }

            const hostname = parsed.hostname;
            const isLocalhost = hostname === 'localhost' || hostname.endsWith('.localhost');
            if (!isLocalhost) {
                if (!hostname || hostname.length < 3 || !hostname.includes('.')) {
                    return 'Enter a valid domain (e.g., https://example.com).';
                }
            }

            return '';
        } catch (error) {
            return 'Enter a valid landing page URL.';
        }
    };

    const updateLandingPageSelection = (value) => {
        const normalizedValue = value || '';
        console.log("handleLandingPageChange", normalizedValue);
        const validationMessage = validateLandingPageUrl(normalizedValue);
        setLandingPageValidationError(validationMessage);

        setCampaignData(prev => ({
            ...prev,
            landing_page_urls: normalizedValue,
            templates: []
        }));

        setLandingPageSelected(false);
        setTemplateSelected(false);
        setTemplatePreview(null);
    };

    const handleLandingPageInputChange = (event) => {
        updateLandingPageSelection(event.target.value);
    };

    const handleAccordionSelect = (eventKey) => {
        if (eventKey === "0" && landingPageSelected) return;
        if (eventKey === "1" && templateAccordionLocked) return;
        setActiveAccordionKeys((prev) => {
            if (prev.includes(eventKey)) {
                return prev.filter((key) => key !== eventKey);
            }
            return [...prev, eventKey];
        });
    };

    // Handler for landing page select button
    const handleLandingPageSelect = async () => {
        if (!campaignData.landing_page_urls || !campaignData.landing_page_urls.trim()) {
            toast.error('Please select a landing page URL first');
            return;
        }

        setSelectLandingPageButtonLoading(true);

        try{
            const trimmedLandingPageUrl = campaignData.landing_page_urls.trim();
            // SDK presence is now a non-blocking check surfaced via the in-accordion
            // banner. The user can verify on demand via that button.
            let client_name_from_url = getNameFromUrl(cleanUrl(trimmedLandingPageUrl))
            let experimentName = shop_domain.replace(".myshopify.com", "") + ( client_name_from_url ? " - " + client_name_from_url : "")
            let featureFlagName = shop_domain.replace(".myshopify.com", "") + ( client_name_from_url ? " - " + client_name_from_url : "")
            const response = await axios.post(`${app_url}/api/cux/experiments`, {
                experimentName: experimentName,
                featureFlagName: featureFlagName,
                landingPageUrl: cleanUrl(trimmedLandingPageUrl)
            }, {withCredentials: true});

            console.log(response)
    
            if(response && response.data && response.data.success){
            }
            else if(response && response.data && !response.data.success && response.data.show_message === true){
                toast.error(response?.data?.message ? response?.data?.message : "Configuration not applied");
            }
            setSelectLandingPageButtonLoading(false);
            
            setLandingPageSelected(true);
            saveData(); // Save the landing page selection
            toast.success('Landing page selected successfully');
        }
        catch(err){
            setSelectLandingPageButtonLoading(false);
            console.error('Error selecting landing page:', err);
            toast.error('Failed to select landing page');
        }

    };

    const handleTemplateRefresh = async () => {
        if (!campaignData?.campaign_id) {
            toast.error('Campaign information is missing.');
            return;
        }
        if (!landingPageSelected) {
            toast.error('Please select a landing page first.');
            return;
        }

        setTemplateRefreshLoading(true);
        try {
            const response = await axios.get(`${app_url}/api/store/personalized_campaigns/${campaignData.campaign_id}/template`, {
                withCredentials: true,
                params: {
                    landing_page_url: campaignData?.landing_page_urls
                }
            });
            if (response?.data?.success) {
                const refreshedCampaign = response?.data?.data || {};
                console.log("refreshedCampaign", refreshedCampaign)
                applyTemplateUpdate(refreshedCampaign);
            } else {
                toast.error(response?.data?.message || 'Failed to refresh template.');
            }
        } catch (error) {
            console.error('Error refreshing template:', error);
            toast.error('Failed to refresh template.');
        } finally {
            setTemplateRefreshLoading(false);
        }
    };

    // Handler for template select button
    const handleTemplateSelect = async () => {
        setSelectTemplateButtonLoading(true);
        try {
            if (!landingPageSelected || !campaignData?.landing_page_urls?.trim()) {
                toast.error('Please select a landing page first');
                setSelectTemplateButtonLoading(false);
                return;
            }
            if (!templatePreview) {
                toast.error('Please refresh to load the latest template before selecting.');
                setSelectTemplateButtonLoading(false);
                return;
            }


            const lockedTemplatePayload = {
                ...templatePreview,
                locked: true
            };
            const cleanedLpUrl = campaignData.landing_page_urls;
            const apiUrl = process.env.REACT_APP_VERSION === 'v2' ? `${app_url}/api/cux/v2/templates` : `${app_url}/api/cux/templates`;
            const response = await axios.post(apiUrl, {
                landingPageUrl: cleanedLpUrl,
                template: lockedTemplatePayload,
                campaign_id: campaignData?.campaign_id,
                campaign_name: campaignData?.campaign_name || 'Untitled Campaign'
            }, {withCredentials: true});

            console.log(response);

            if (response && response.data && response.data.success) {
                // Lock template selection and persist
                setTemplateSelected(true);
                const updatedCampaign = {
                    ...campaignData,
                    templates: lockedTemplatePayload
                };
                saveData(null, updatedCampaign);
                toast.success('Template selected successfully');
            } else if (response && response.data && !response.data.success && response.data.show_message) {
                toast.error(response?.data?.message ? response?.data?.message : 'Configuration not applied');
            }
            setSelectTemplateButtonLoading(false);
        } catch (error) {
            console.error('Error selecting Template:', error);
            toast.error('Failed to select Template');
            setSelectTemplateButtonLoading(false);
        }
    };

    // Handler for template select
    const handleTemplateChange = (value) => {
        setCampaignData(prev => ({
            ...prev,
            templates: value ? value : {},
            // Add sections_rearrangement for all templates
            ...(value && value.sections_rearrangement && { sections_rearrangement: value.sections_rearrangement })
        }));
        // Do not saveData here, only on select button click
    };

    // Handler for status dropdown
    const handleStatusChange = (selected) => {
        setStatus(selected);
        setCampaignData(prev => ({...prev, status: selected.value}));
        saveData(selected.value);
    };

    // Logic Updated: Targeting Handlers
    const handleCreateTargeting = () => {
        // Create new targeting item
        const newTargetingItem = {
            id: uuidv4(),
            name: `Untitled Variant`,
            status: 'enabled',
            targeting: [],
            value: []
        };
        console.log("campaignData", campaignData)
        // Navigate based on category
        if (campaignData.category === 'Custom Campaign') {
            navigate('/custom-campaign-personalization', {
                state: {
                    campaignData: campaignData,
                    targetingItem: newTargetingItem,
                    previousPage: 'personalization-campaign',
                    allTargeting: initialallTargeting
                }
            });
        } else if (campaignData.category === 'Keyword Personalization') {
            navigate('/landing-page-optimization', {
                state: {
                    campaignData: campaignData,
                    targetingItem: newTargetingItem,
                    previousPage: 'personalization-campaign',
                    allTargeting: initialallTargeting
                }
            });
        } else if (campaignData.category === 'Ads Personalization') {
            navigate('/meta-ads-personalization', {
                state: {
                    campaignData: campaignData,
                    targetingItem: newTargetingItem,
                    previousPage: 'personalization-campaign',
                    allTargeting: initialallTargeting
                }
            });
        } else if (campaignData.category === 'AI Landing Page') {
            navigate('/ai-response-editor', {
                state: {
                    campaignData: campaignData,
                    targetingItem: newTargetingItem,
                    previousPage: 'personalization-campaign',
                    allTargeting: initialallTargeting
                }
            });
        }
    };

    const handleEditTargeting = (id) => {
        // Find the targeting item to edit
        const targetingItem = campaignData.targeting_and_content.find(item => item.id === id);
        if (!targetingItem) {
            toast.error('Could not find targeting item to edit.');
            return;
        }

        // Handle Custom Campaign editing
        if (campaignData.category.toLowerCase() === 'custom campaign') {
            navigate('/custom-campaign-personalization', {
                state: {
                    campaignData: campaignData,
                    targetingItem: targetingItem,
                    allTargeting: initialallTargeting,
                    previousPage: 'personalization-campaign'
                }
            });
            return;
        }

        // For other categories, redirect to appropriate page
        const category = campaignData.category.toLowerCase();
        if (category === 'keyword personalization') {
            navigate('/landing-page-optimization', {
                state: {
                    campaignData: campaignData,
                    targetingItem: targetingItem,
                    allTargeting: initialallTargeting,
                    previousPage: 'personalization-campaign'
                }
            });
        } else if (category === 'ads personalization') {
            navigate('/meta-ads-personalization', {
                state: {
                    campaignData: campaignData,
                    targetingItem: targetingItem,
                    allTargeting: initialallTargeting,
                    previousPage: 'personalization-campaign'
                }
            });
        } else if (category === 'ai landing page') {
            navigate('/ai-response-editor', {
                state: {
                    campaignData: campaignData,
                    targetingItem: targetingItem,
                    allTargeting: initialallTargeting,
                    previousPage: 'personalization-campaign'
                }
            });
        }
    };

    const handleDeleteTargeting = (id) => {
        console.log(`Deleting targeting with id: ${id}`);
        if (!window.confirm('Are you sure you want to delete this targeting item?')) return;

        const targetItem = campaignData.targeting_and_content.find(item => item.id === id);
        const variantKeys = (targetItem?.targeting || [])
            .map(t => typeof t === 'string' ? t : (t?.label || t?.value || ''))
            .filter(Boolean);

        axios.post(`${app_url}/api/cux/delete-variant`, { campaign_id: campaignData.campaign_id, variant_id: id, landing_page_url: campaignData.landing_page_urls }, { withCredentials: true })
            .then(() => {
                setCampaignData(prev => ({
                    ...prev,
                    targeting_and_content: prev.targeting_and_content.filter(item => item.id !== id)
                }));
                saveData(); // Save after deleting (local/session)
                toast.success('Targeting item deleted.');
            })
            .catch(err => {
                console.error('Error cleaning up GrowthBook flags', err);
                toast.error(errorMessages["DATA_DELETE_ERROR"]?.title || 'Failed to delete targeting');
            });
    };


    // --- Save/Publish ---
    const saveData = (newStatus = null, overrideCampaign = null) => {
        const sourceCampaign = overrideCampaign || campaignData;
        if (!sourceCampaign || !sourceCampaign.campaign_id) {
            console.error("Cannot save: Campaign data or ID is missing.", sourceCampaign);
            toast.error("Cannot save: Campaign ID is missing.");
            return false;
        }

        let campaigns = getCampaignsFromStorage();
        const campaignIndex = campaigns.findIndex(c => c.campaign_id === sourceCampaign.campaign_id);

        // Prepare data, ensuring lpPreview is saved correctly
        const dataToSave = {
            ...sourceCampaign
        };

        if (newStatus) {
            dataToSave.status = newStatus;
        }

        if (campaignIndex > -1) {
            campaigns[campaignIndex] = dataToSave;
            console.log("Updated campaign in storage:", dataToSave);
        } else {
            campaigns.push(dataToSave);
            console.log("Added new campaign to storage:", dataToSave);
        }
        saveCampaignsToStorage(campaigns);
        // Update local state if status was changed externally (like via publish)
        if (!overrideCampaign && newStatus && newStatus !== (campaignData?.status)) {
            setCampaignData(dataToSave);
        } else if (overrideCampaign) {
            setCampaignData(dataToSave);
        }
        return true;
    };

    const handlePublish = async () => {
        if (!landingPageSelected || !campaignData?.landing_page_urls?.trim()) {
            toast.error('Please select a landing page first.');
            return;
        }
        setPublishBtnLoading(true);
        try {
            const response = await axios.post(
                `${app_url}/api/cux/publish-campaign`,
                {campaignData},
                {withCredentials: true}
            );

            if (response.data.success) {
                toast.success('Campaign saved successfully!');
                // Navigate back to summary page
                // navigate('/campaign-summary');
            } else {
                throw new Error(response.data.message || 'Failed to publish campaign');
            }
        } catch (error) {
            console.error('Error publishing campaign:', error);
            toast.error(errorMessages["PUBLISH_ERROR"]["title"]);
        } finally {
            setPublishBtnLoading(false);
        }
    };
    // --- End Logic Added ---


    const getFilteredTargetingItems = () => {
        const sourceItems = Array.isArray(campaignData?.targeting_and_content)
            ? campaignData.targeting_and_content
            : [];

        const searchQuery = targetingSearch.trim().toLowerCase();
        if (!searchQuery) return sourceItems;

        return sourceItems.filter((item) => {
            const nameText = (item.name || '').toString().toLowerCase();
            const targetingText = Array.isArray(item.targeting)
                ? item.targeting
                    .map((t) => (typeof t === 'string' ? t : ((t && (t.label || t.value)) || '')))
                    .join(' ')
                    .toLowerCase()
                : (item.targeting || '').toString().toLowerCase();

            return nameText.includes(searchQuery) || targetingText.includes(searchQuery);
        });
    };

    const getTargetingTableData = () => {
        const includeFinalUrl = (campaignData?.category === 'Custom Campaign') || (campaignData?.category === 'AI Landing Page');
        const headers = includeFinalUrl ? ['Name', 'Status', 'Targeting', 'LP Preview URL', 'Final URL', 'Actions'] : ['Name', 'Status', 'Targeting', 'LP Preview URL', 'Actions'];

        const filteredItems = getFilteredTargetingItems();
        const totalPages = Math.max(1, Math.ceil(filteredItems.length / TARGETING_CONTENT_PAGE_SIZE));
        const effectivePage = Math.max(1, Math.min(targetingContentTablePage, totalPages));
        const items = filteredItems.slice(
            (effectivePage - 1) * TARGETING_CONTENT_PAGE_SIZE,
            effectivePage * TARGETING_CONTENT_PAGE_SIZE
        );

        const rows = items.map((item) => {
            // Get the first targeting element
            const firstTargeting = Array.isArray(item.targeting) && item.targeting.length > 0
                ? (item.targeting[0]?.value && Array.isArray(item.targeting[0]?.value) && item.targeting[0]?.value.length > 0 && item.targeting[0]?.value[0]?.keyword_text ? item.targeting[0]["value"][0]["keyword_text"] : "N/A")
                : (typeof item.targeting === 'string' ? item.targeting : 'N/A');

            // Create a tooltip with all targeting elements
            const fullTargeting = Array.isArray(item.targeting)
                ? item.targeting.map((iter) => iter["label"]).join('\n')
                : (typeof item.targeting === 'string' ? item.targeting : 'N/A');

            // Status badge (Figma: pill with dot + text – Enabled green, Draft/Live variants)
            const statusValue = (item.status || '').toLowerCase();
            const statusModifier = statusValue === 'enabled' || statusValue === 'live' ? (statusValue === 'live' ? 'live' : 'enabled') : (statusValue === 'draft' ? 'draft' : 'default');
            const statusLabel = item.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1) : 'N/A';
            const statusBadgeHtml = `<span class="sxi-status-badge sxi-status-badge--${statusModifier}"><span class="sxi-status-badge__dot"></span><span class="sxi-status-badge__text">${statusLabel}</span></span>`;

            const lpPreviewCell = item.lpPreview ?
                `<a href="${item.lpPreview}" target="_blank" class="btn btn-sm btn-outline-primary" style="padding: 0.25rem 0.5rem; font-size: 0.875rem; text-decoration: none;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye me-1" viewBox="0 0 16 16">
              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
            </svg>
            Preview
          </a>`
                : '-';

            const finalUrlValue = includeFinalUrl
                ? (item.lpFinalUrl || (campaignData?.landing_page_urls && item?.targeting?.[0]
                    ? `${campaignData.landing_page_urls}?sxi_content=${typeof item.targeting[0] === 'string' ? item.targeting[0] : (item.targeting[0]?.value || item.targeting[0]?.label || '')}`
                    : ''))
                : '';

            const finalUrlCell = includeFinalUrl
                ? (finalUrlValue
                    ? `<a href="${finalUrlValue}" target="_blank" class="btn btn-sm btn-outline-primary" style="padding: 0.25rem 0.5rem; font-size: 0.875rem; text-decoration: none;">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-link-45deg me-1" viewBox="0 0 16 16">
          <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.372-1.372-.708-.708-1.372 1.372a2 2 0 1 1-2.828-2.828l1.372-1.372-.707-.707z"/>
          <path d="M6.586 4.671 7.95 3.307a3 3 0 0 1 4.243 4.243l-1.372 1.372-.708-.708 1.372-1.372a2 2 0 1 0-2.828-2.828L7.536 6.379l-.707-.707z"/>
          <path d="M6.586 9.414 9.414 6.586l.707.707-2.828 2.828-.707-.707z"/>
        </svg>
        Final
      </a>`
                    : '-')
                : null;

            const editIconSvg = `<svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="sxi-edit-icon"><g clip-path="url(#clip0_edit_${item.id})"><path d="M19.1667 13.3333H15.6667C14.2666 13.3333 13.5666 13.3333 13.0318 13.6058C12.5614 13.8455 12.1789 14.2279 11.9392 14.6983C11.6667 15.2331 11.6667 15.9332 11.6667 17.3333V24.3333C11.6667 25.7335 11.6667 26.4335 11.9392 26.9683C12.1789 27.4387 12.5614 27.8212 13.0318 28.0608C13.5666 28.3333 14.2666 28.3333 15.6667 28.3333H22.6667C24.0669 28.3333 24.7669 28.3333 25.3017 28.0608C25.7721 27.8212 26.1546 27.4387 26.3943 26.9683C26.6667 26.4335 26.6667 25.7335 26.6667 24.3333V20.8333M16.6667 23.3333H18.0622C18.4698 23.3333 18.6737 23.3333 18.8655 23.2873C19.0355 23.2464 19.1981 23.1791 19.3472 23.0877C19.5154 22.9847 19.6595 22.8405 19.9478 22.5523L27.9167 14.5833C28.6071 13.893 28.6071 12.7737 27.9167 12.0833C27.2264 11.393 26.1071 11.393 25.4167 12.0833L17.4478 20.0523C17.1595 20.3405 17.0154 20.4847 16.9123 20.6528C16.8209 20.802 16.7536 20.9645 16.7128 21.1346C16.6667 21.3264 16.6667 21.5302 16.6667 21.9379V23.3333Z" stroke="#475467" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_edit_${item.id}"><rect width="20" height="20" fill="white" transform="translate(10 10)"/></clipPath></defs></svg>`;
            const actionsCell = `<div class="d-flex gap-1">

          <button class="btn btn-sm btn-link p-0 me-2" onclick="window.handleEditTargeting('${item.id}')" title="Edit" style="color: #475467; line-height: 0">
            ${editIconSvg}
          </button>

          <button class="btn btn-sm btn-link p-0" onclick="window.handleDeleteTargeting('${item.id}')" title="Delete" style="color: #475467; line-height: 0">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.3333 15V14.3334C23.3333 13.3999 23.3333 12.9332 23.1517 12.5767C22.9919 12.2631 22.7369 12.0081 22.4233 11.8483C22.0668 11.6667 21.6001 11.6667 20.6667 11.6667H19.3333C18.3999 11.6667 17.9332 11.6667 17.5767 11.8483C17.2631 12.0081 17.0081 12.2631 16.8483 12.5767C16.6667 12.9332 16.6667 13.3999 16.6667 14.3334V15M18.3333 19.5834V23.75M21.6667 19.5834V23.75M12.5 15H27.5M25.8333 15V24.3334C25.8333 25.7335 25.8333 26.4336 25.5608 26.9683C25.3212 27.4387 24.9387 27.8212 24.4683 28.0609C23.9335 28.3334 23.2335 28.3334 21.8333 28.3334H18.1667C16.7665 28.3334 16.0665 28.3334 15.5317 28.0609C15.0613 27.8212 14.6788 27.4387 14.4392 26.9683C14.1667 26.4336 14.1667 25.7335 14.1667 24.3334V15" stroke="#475467" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <!--<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/><path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/></svg>-->
          </button>
        </div>`
            const baseRow = [
                item.name,
                statusBadgeHtml,
                `<div title="${fullTargeting}">${firstTargeting}</div>`,
                lpPreviewCell
            ];

            if (includeFinalUrl) {
                baseRow.push(finalUrlCell);
            }

            baseRow.push(actionsCell);
            return baseRow;
        });
        return [headers, ...rows];
    };


    useEffect(() => {
        window.handleEditTargeting = (id) => {
            handleEditTargeting(id);
        };

        window.handleDeleteTargeting = (id) => {
            handleDeleteTargeting(id);
        };

        return () => {
            delete window.handleEditTargeting;
            delete window.handleDeleteTargeting;
            clearTemplatePolling(true);
        };
    }, [campaignData]);

    useEffect(() => {
        // Reset to first page when user changes search
        setTargetingContentTablePage(1);
    }, [targetingSearch]);

    const handleBack = () => {
        if (previousPage === 'category') {
            navigate('/category', {state: {campaignData: campaignData, allTargeting: initialallTargeting}});
        } else {
            navigate('/campaign-summary');
        }
    };

    // Render Loading state
    if (loading || !campaignData) {
        return (
            <div className='main-container' style={{position: "relative"}}>
                <div className="text-center mt-5">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading Campaign...</span>
                    </Spinner>
                </div>
            </div>
        );
    }


    return (
        <div className='main-container'>
            {!shop_domain ? (
                <div className='go_to_shopify_admin_div'>
                    <h5 style={{display: 'inline-block'}}>!! Go to Shopify Admin and open our app !!</h5>
                </div>
            ) : (
                <>
                    {loading ? (
                        <div className="text-center mt-5">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading Campaign...</span>
                            </Spinner>
                        </div>
                    ) : (
                        <>
                            {/* <div className="campaign-top-nav">
                                <Breadcrumbs campaignData={campaignData}/>
                            </div> */}

                            <Container fluid className="mx-0">
                                <Row className="mb-4">
                                    <Col className="d-flex align-items-center justify-content-between" style={{'paddingLeft':'5px', 'paddingRight':'5px'}}>
                                        <div className="custom-campaign-personalization-title d-flex justify-content-between align-items-start w-100 mx-0">
                                        <div className="d-flex flex-column">
                                            <div className="d-flex align-items-center gap-2">
                                            {isEditingName ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={campaignData.campaign_name}
                                                    onChange={handleCampaignNameChange}
                                                    onBlur={handleCampaignNameBlur}
                                                    onKeyDown={handleCampaignNameKeyDown}
                                                    ref={campaignNameInputRef}
                                                    style={{
                                                        fontSize: '1.40rem',
                                                        fontWeight: 'bold',
                                                        width: 'auto',
                                                        minWidth: '180px'
                                                    }}
                                                />
                                            ) : (
                                                <OverlayTrigger
                                                    placement="bottom"
                                                    overlay={
                                                        <Tooltip id="campaign-title-description-tooltip" className="sxi-campaign-edit-tooltip single-line-tooltip" style={{marginLeft: '4rem'}}>
                                                            Configure your AI-powered personalization campaign
                                                        </Tooltip>
                                                    }
                                                >
                                                    <h2 style={{
                                                        marginBottom: 0,
                                                        fontSize: '1.40rem',
                                                        fontWeight: 'bold',
                                                        cursor: 'help',
                                                        color: '#052c65'
                                                    }}>{campaignData.campaign_name}</h2>
                                                </OverlayTrigger>
                                            )}
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="campaign-title-edit-tooltip" className="sxi-campaign-edit-tooltip">
                                                        Edit the title by clicking on the icon
                                                    </Tooltip>
                                                }
                                            >
                                                <button
                                                    className="btn btn-sm btn-link p-0"
                                                    onClick={handleCampaignNameEdit}
                                                >
                                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V17.2C2 18.8802 2 19.7202 2.32698 20.362C2.6146 20.9265 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V13M7.99997 16H9.67452C10.1637 16 10.4083 16 10.6385 15.9447C10.8425 15.8957 11.0376 15.8149 11.2166 15.7053C11.4184 15.5816 11.5914 15.4086 11.9373 15.0627L21.5 5.5C22.3284 4.67157 22.3284 3.32843 21.5 2.5C20.6716 1.67157 19.3284 1.67157 18.5 2.5L8.93723 12.0627C8.59133 12.4086 8.41838 12.5816 8.29469 12.7834C8.18504 12.9624 8.10423 13.1575 8.05523 13.3615C7.99997 13.5917 7.99997 13.8363 7.99997 14.3255V16Z" stroke="#AAAAAA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </button>
                                            </OverlayTrigger>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <span className="campaign-tag-new me-2">{campaignData.category || 'Campaign'}</span>
                                            {/* <span className="fw-bold mt-0 me-2" style={{ fontSize: '14px', lineHeight: 1.2 }}>Status</span> */}
                                            <div style={{width: '100px', display: 'flex', alignItems: 'center', height: '24px'}}>
                                                <ReMultiSelect
                                                    closeMenuOnSelect={true}
                                                    components={ReMultiSelectAnimated()}
                                                    menuPortalTarget={document.body}
                                                    menuPosition="fixed"
                                                    styles={statusDropdownStyles}
                                                    value={status}
                                                    options={statusOptions}
                                                    onChange={handleStatusChange}
                                                />
                                            </div>
                                        </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>

                            {/* Split into Two Separate Accordions */}
                            <div className='main-accordion-body mt-4 p-2'>
                                <Accordion activeKey={activeAccordionKeys} onSelect={handleAccordionSelect}>
                                    {/* Landing Page Selection Accordion */}
                                    <Accordion.Item
                                        eventKey="0"
                                        style={landingPageSelected ? lockedAccordionStyle : undefined}
                                    >
                                        <Accordion.Header>
                                            <div className="d-flex align-items-center justify-content-between w-100">
                                                <div className="sxi-accordion-header-with-icon">
                                                    <div className="sxi-accordion-header-icon" aria-hidden="true">
                                                        <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g filter="url(#filter0_d_62_1564)">
                                                                <rect x="3" y="3" width="48" height="48" rx="6" fill="#E5EEFF" shapeRendering="crispEdges" />
                                                                <rect x="3" y="3" width="48" height="48" rx="6" stroke="#CEDEFF" shapeRendering="crispEdges" />
                                                                <path d="M28.0833 16.1667L18.4345 27.7452C18.0566 28.1986 17.8677 28.4254 17.8648 28.6168C17.8623 28.7833 17.9365 28.9417 18.066 29.0463C18.2149 29.1667 18.51 29.1667 19.1003 29.1667H26.9999L25.9166 37.8333L35.5654 26.2548C35.9432 25.8014 36.1322 25.5747 36.1351 25.3832C36.1376 25.2167 36.0634 25.0583 35.9339 24.9537C35.785 24.8333 35.4898 24.8333 34.8996 24.8333H26.9999L28.0833 16.1667Z" stroke="#2056C1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </g>
                                                            <defs>
                                                                <filter id="filter0_d_62_1564" x="0.5" y="0.5" width="57" height="57" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                                    <feOffset dx="2" dy="2" />
                                                                    <feGaussianBlur stdDeviation="2" />
                                                                    <feComposite in2="hardAlpha" operator="out" />
                                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_62_1564" />
                                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_62_1564" result="shape" />
                                                                </filter>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                    <LockedHeader
                                                        label="Select Landing Page"
                                                        locked={landingPageSelected}
                                                        reason="Landing page is already selected"
                                                        additionalContent={landingPageSelected ? `Selected Landing Page URL: ${campaignData.landing_page_urls}` : null}
                                                    />
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                    {landingPageSelected && <AccordionLockIcon reason="Landing page is already selected" />}
                                                    <span className={`campaign-accordion-chevron ${activeAccordionKeys.includes('0') ? 'open' : ''}`} aria-hidden="true">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Container fluid className="px-0">
                                                <Row className="mb-2 mt-3">
                                                    <Col xs={12} md={8} className="mb-3 mb-md-0">
                                                        {/* <Label className="charts_filter_label mt-2">Landing page URL</Label> */}
                                                        <input
                                                            type="text"
                                                            className={`form-control ${landingPageValidationError ? 'is-invalid' : ''}`}
                                                            value={campaignData?.landing_page_urls || ''}
                                                            onChange={handleLandingPageInputChange}
                                                            placeholder="Landing page URL"
                                                            disabled={landingPageSelected}
                                                            />
                                                    </Col>
                                                    <Col xs={12} md={4} className="d-flex align-items-end">
                                                        {select_landing_page_button_loading ? (
                                                            <Button className="sxi_primary_blue_btn" disabled>
                                                                <Spinner size="sm" animation="border"/>
                                                            </Button>
                                                        ) : (
                                                            <Button 
                                                                onClick={handleLandingPageSelect} 
                                                                className="sxi_primary_blue_btn btn-height" 
                                                                disabled={
                                                                    landingPageSelected ||
                                                                    !campaignData.landing_page_urls ||
                                                                    !campaignData.landing_page_urls.trim() ||
                                                                    Boolean(landingPageValidationError)
                                                                }
                                                            >
                                                                Select
                                                            </Button>
                                                        )}
                                                    </Col>
                                                    
                                                    {landingPageValidationError && (
                                                        <div className="invalid-feedback d-block">
                                                            {landingPageValidationError}
                                                        </div>
                                                    )}
                                                </Row>
                                                <div style={{fontSize: '0.95rem'}}>
                                                    Note: Once selected, the landing page cannot be changed.
                                                </div>
                                            </Container>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    {/* SDK verification banner — sits between accordions so it stays
                                        visible after the landing-page accordion auto-collapses on select. */}
                                    {landingPageSelected && sdkVerifyState !== 'verified' && (
                                        <div
                                            role="status"
                                            aria-live="polite"
                                            style={{
                                                margin: '12px 0',
                                                border: `1px solid ${sdkVerifyState === 'failed' ? '#f5c2c7' : '#ffe69c'}`,
                                                background: sdkVerifyState === 'failed' ? '#fdecea' : '#fff8e1',
                                                borderRadius: '6px',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            {/* Compact header — collapsed by default; click to reveal the full message */}
                                            <button
                                                type="button"
                                                onClick={() => setSdkNoticeOpen(o => !o)}
                                                aria-expanded={sdkNoticeOpen}
                                                style={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    padding: '6px 12px',
                                                    background: 'transparent',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    textAlign: 'left'
                                                }}
                                            >
                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                                    <path d="M12 3L22 20H2L12 3Z" stroke={sdkVerifyState === 'failed' ? '#b91c1c' : '#b88600'} strokeWidth="1.6" strokeLinejoin="round"/>
                                                    <path d="M12 10V14" stroke={sdkVerifyState === 'failed' ? '#b91c1c' : '#b88600'} strokeWidth="1.6" strokeLinecap="round"/>
                                                    <circle cx="12" cy="17" r="1" fill={sdkVerifyState === 'failed' ? '#b91c1c' : '#b88600'}/>
                                                </svg>
                                                <span style={{flex: 1, minWidth: 0, fontSize: '0.78rem', fontWeight: 600, color: sdkVerifyState === 'failed' ? '#7f1d1d' : '#6b5300'}}>
                                                    {sdkVerifyState === 'failed'
                                                        ? 'SDK verification failed'
                                                        : 'SDK connection not verified'}
                                                </span>
                                                <span className={`campaign-accordion-chevron ${sdkNoticeOpen ? 'open' : ''}`} aria-hidden="true">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                            </button>

                                            {/* Full message + verify action — revealed on expand */}
                                            {sdkNoticeOpen && (
                                                <div style={{padding: '0 12px 12px 12px', display: 'flex', alignItems: 'flex-start', gap: '12px'}}>
                                                    <div style={{flex: 1, minWidth: 0, fontSize: '0.9rem', color: '#555'}}>
                                                        {sdkVerifyState === 'failed' && sdkVerifyError
                                                            ? sdkVerifyError
                                                            : "The SDK may not be present on your website. If you're confident it's installed, you can still create the campaign — but the variations won't be shown to visitors if the SDK isn't present."}
                                                    </div>
                                                    <div style={{flex: '0 0 auto'}}>
                                                        <Button
                                                            size="sm"
                                                            onClick={handleSdkVerifyClick}
                                                            disabled={sdkVerifyState === 'verifying'}
                                                            className="sxi_primary_blue_btn"
                                                        >
                                                            {sdkVerifyState === 'verifying' ? (
                                                                <>
                                                                    <Spinner size="sm" animation="border" style={{marginRight: '6px'}}/>
                                                                    Verifying…
                                                                </>
                                                            ) : sdkVerifyState === 'failed' ? 'Retry verification' : 'Verify connection'}
                                                        </Button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {/* Template Selection Accordion */}
                                    <Accordion.Item
                                        eventKey="1"
                                        style={templateAccordionLocked ? lockedAccordionStyle : undefined}
                                    >
                                        <Accordion.Header>
                                            <div className="d-flex align-items-center justify-content-between w-100">
                                                <div className="sxi-accordion-header-with-icon">
                                                    <div className="sxi-accordion-header-icon" aria-hidden="true">
                                                        <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g filter="url(#filter0_d_62_1564)">
                                                                <rect x="3" y="3" width="48" height="48" rx="6" fill="#E5EEFF" shapeRendering="crispEdges" />
                                                                <rect x="3" y="3" width="48" height="48" rx="6" stroke="#CEDEFF" shapeRendering="crispEdges" />
                                                                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" transform="translate(17 17)" stroke="#2056C1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                                                            </g>
                                                            <defs>
                                                                <filter id="filter0_d_62_1564" x="0.5" y="0.5" width="57" height="57" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                                    <feOffset dx="2" dy="2" />
                                                                    <feGaussianBlur stdDeviation="2" />
                                                                    <feComposite in2="hardAlpha" operator="out" />
                                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_62_1564" />
                                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_62_1564" result="shape" />
                                                                </filter>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                    <LockedHeader
                                                        label="Select Template"
                                                        locked={templateAccordionLocked}
                                                        reason="Template is already selected"
                                                    />
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                    {templateAccordionLocked && <AccordionLockIcon reason="Template is already selected" />}
                                                    <span className={`campaign-accordion-chevron ${activeAccordionKeys.includes('1') ? 'open' : ''}`} aria-hidden="true">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body className='px-0'>
                                            <Container fluid className="px-0">
                                                {!landingPageSelected ? (
                                                    <div className="py-4">
                                                        <div>
                                                            Please select a landing page first to work with templates.
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <Row className="mb-3 px-4">
                                                            <Col className="d-flex flex-wrap mt-3 gap-2">
                                                                <Button
                                                                    className="sxi_primary_blue_btn btn-height"
                                                                    onClick={handleLaunchVisualEditor}
                                                                    disabled={!canLaunchVisualEditor}
                                                                >
                                                                    Launch Visual Editor
                                                                </Button>
                                                                <Button
                                                                    className='back-button btn-height'
                                                                    // variant="outline-secondary"
                                                                    onClick={handleTemplateRefresh}
                                                                    disabled={templateRefreshLoading}
                                                                >
                                                                    {templateRefreshLoading ? (
                                                                        <>
                                                                            <Spinner size="sm" animation="border" className="me-2"/>
                                                                            Refreshing...
                                                                        </>
                                                                    ) : (
                                                                        'Refresh Template'
                                                                    )}
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                        <div className=" mb-3 px-4" style={{fontSize: '0.9rem'}}>
                                                            No template data yet. Launch the editor, make your changes, then click Refresh.
                                                        </div>
                                                        {templatePreview ? (
                                                            <>
                                                                <div className="mt-3 personalization-targeting-table">
                                                                    <Table responsive className="mb-0">
                                                                        <thead>
                                                                            <tr>
                                                                                <th className="channel_performance_header_cell">Label</th>
                                                                                <th className="channel_performance_header_cell">Type</th>
                                                                                <th className="channel_performance_header_cell">View</th>
                                                                                <th className="channel_performance_header_cell">Selector</th>
                                                                                <th className="channel_performance_header_cell">Value</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {getCustomizedSections(templatePreview).length === 0 ? (
                                                                                <tr className="channel_performance_table_row">
                                                                                    <td colSpan={5} className="channel_performance_table_cell text-center">
                                                                                        No customized sections were returned. Make sure you saved from the Visual Editor and try refreshing again.
                                                                                    </td>
                                                                                </tr>
                                                                            ) : (
                                                                                getCustomizedSections(templatePreview).map((section, index) => (
                                                                                    <tr
                                                                                        key={`${section.selector}-${index}`}
                                                                                        className={index % 2 === 0 ? 'channel_performance_table_row' : 'channel_performance_old_table_row'}
                                                                                    >
                                                                                        <td className="channel_performance_table_cell">{section.label || '-'}</td>
                                                                                        <td className="channel_performance_table_cell">{section.type || '-'}</td>
                                                                                        <td className="channel_performance_table_cell">{section.view || '-'}</td>
                                                                                        <td className="channel_performance_table_cell">{section.selector || '-'}</td>
                                                                                        <td className="channel_performance_table_cell" style={{whiteSpace: 'pre-wrap'}}>{section.value || '-'}</td>
                                                                                    </tr>
                                                                                ))
                                                                            )}
                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                                <div className="px-4" style={{fontSize: '0.9rem'}}>
                                                                    Review the updates above. Once selected, the template for this campaign cannot be changed.
                                                                </div>
                                                                <div className="mt-3 px-4">
                                                                {select_template_button_loading ? (
                                                                    <Button className="sxi_primary_blue_btn" disabled>
                                                                        <Spinner size="sm" animation="border"/>
                                                                    </Button>
                                                                ) : (
                                                                    <Button 
                                                                        onClick={handleTemplateSelect} 
                                                                        className="sxi_primary_blue_btn btn-height" 
                                                                            disabled={templateAccordionLocked}
                                                                    >
                                                                        Select Template
                                                                    </Button>
                                                                )}
                                                        </div>
                                                            </>
                                                        ) : (''
                                                            // <div className="text-center py-4">
                                                            //     <em>No template data yet. Launch the editor, make your changes, then click Refresh.</em>
                                                            // </div>
                                                        )}
                                                    </>
                                                )}
                                            </Container>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    {/* Targeting & Content Accordion */}
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>
                                            <div className="d-flex align-items-center justify-content-between w-100">
                                                <div className="sxi-accordion-header-with-icon">
                                                    <div className="sxi-accordion-header-icon" aria-hidden="true">
                                                        <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g filter="url(#filter0_d_67_2322)">
                                                                <rect x="3" y="3" width="48" height="48" rx="6" fill="#E5EEFF" shapeRendering="crispEdges" />
                                                                <rect x="3" y="3" width="48" height="48" rx="6" stroke="#CEDEFF" shapeRendering="crispEdges" />
                                                                <path d="M34.414 22.5312C34.2652 24.5965 32.7332 26.1875 31.0625 26.1875C29.3918 26.1875 27.8571 24.597 27.7109 22.5312C27.5586 20.3827 29.05 18.875 31.0625 18.875C33.0749 18.875 34.5664 20.4218 34.414 22.5312Z" stroke="#2056C1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M31.0623 29.4375C27.7529 29.4375 24.5704 31.0813 23.7732 34.2825C23.6675 34.7061 23.9331 35.125 24.3683 35.125H37.7568C38.192 35.125 38.456 34.7061 38.3519 34.2825C37.5547 31.03 34.3722 29.4375 31.0623 29.4375Z" stroke="#2056C1" strokeWidth="2" strokeMiterlimit="10" />
                                                                <path d="M24.1564 23.4423C24.0375 25.0916 22.7995 26.3906 21.465 26.3906C20.1304 26.3906 18.8904 25.0921 18.7736 23.4423C18.6522 21.7264 19.8572 20.5 21.465 20.5C23.0727 20.5 24.2777 21.7579 24.1564 23.4423Z" stroke="#2056C1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M24.4609 29.5391C23.5443 29.1191 22.5348 28.9576 21.4649 28.9576C18.8242 28.9576 16.2801 30.2703 15.6428 32.8271C15.559 33.1653 15.7713 33.5 16.1186 33.5H21.8203" stroke="#2056C1" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
                                                            </g>
                                                            <defs>
                                                                <filter id="filter0_d_67_2322" x="0.5" y="0.5" width="57" height="57" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                                    <feOffset dx="2" dy="2" />
                                                                    <feGaussianBlur stdDeviation="2" />
                                                                    <feComposite in2="hardAlpha" operator="out" />
                                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_67_2322" />
                                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_67_2322" result="shape" />
                                                                </filter>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                    <span>Targeting & Content</span>
                                                </div>
                                                <span className={`campaign-accordion-chevron ${activeAccordionKeys.includes('2') ? 'open' : ''}`} aria-hidden="true">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M4.5 6L8 9.5L11.5 6" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            {/* Original Targeting Body Structure */}
                                            <Container fluid className="px-0 pt-2">
                                                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3 mt-3 mx-4">
                                                    <Button
                                                        className='d-flex align-items-center justify-content-center sxi_primary_blue_btn btn-height'
                                                        style={{marginBottom: '4px'}}
                                                        onClick={handleCreateTargeting}
                                                        disabled={!templateAccordionLocked}
                                                    >
                                                        <svg className="me-1" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M18 12.998H13V17.998C13 18.2632 12.8946 18.5176 12.7071 18.7051C12.5196 18.8926 12.2652 18.998 12 18.998C11.7348 18.998 11.4804 18.8926 11.2929 18.7051C11.1054 18.5176 11 18.2632 11 17.998V12.998H6C5.73478 12.998 5.48043 12.8926 5.29289 12.7051C5.10536 12.5176 5 12.2632 5 11.998C5 11.7328 5.10536 11.4784 5.29289 11.2909C5.48043 11.1033 5.73478 10.998 6 10.998H11V5.99799C11 5.73277 11.1054 5.47842 11.2929 5.29088C11.4804 5.10334 11.7348 4.99799 12 4.99799C12.2652 4.99799 12.5196 5.10334 12.7071 5.29088C12.8946 5.47842 13 5.73277 13 5.99799V10.998H18C18.2652 10.998 18.5196 11.1033 18.7071 11.2909C18.8946 11.4784 19 11.7328 19 11.998C19 12.2632 18.8946 12.5176 18.7071 12.7051C18.5196 12.8926 18.2652 12.998 18 12.998Z" fill="white"/>
                                                        </svg>
                                                        Create
                                                    </Button>
                                                    <div className="flex-grow-1 position-relative" style={{maxWidth: '200px'}}>
                                                        <span className="position-absolute top-50 start-0 translate-middle-y d-flex align-items-center justify-content-center ps-3" style={{zIndex: 2}} aria-hidden="true">
                                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z" stroke="#667085" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            // placeholder="Search variants"
                                                            value={targetingSearch}
                                                            onChange={(e) => setTargetingSearch(e.target.value)}
                                                            style={{paddingLeft: '2.5rem'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-3 personalization-targeting-table">
                                                    {campaignData.targeting_and_content.length > 0 ? (
                                                        <>
                                                            <Chart
                                                                chartType="Table"
                                                                width="100%"
                                                                data={getTargetingTableData()}
                                                                options={{
                                                                    width: '100%',
                                                                    curveType: "function",
                                                                    legend: {position: "bottom"},
                                                                    cssClassNames: {
                                                                        tableCell: "channel_performance_table_cell",
                                                                        headerCell: "channel_performance_header_cell",
                                                                        tableRow: "channel_performance_table_row",
                                                                        oddTableRow: "channel_performance_old_table_row"
                                                                    },
                                                                    allowHtml: true,
                                                                    page: 'disable'
                                                                }}
                                                            />

                                                            {(() => {
                                                                const filteredItems = getFilteredTargetingItems();
                                                                const totalPages = Math.max(
                                                                    1,
                                                                    Math.ceil(filteredItems.length / TARGETING_CONTENT_PAGE_SIZE)
                                                                );
                                                                const effectivePage = Math.max(
                                                                    1,
                                                                    Math.min(targetingContentTablePage, totalPages)
                                                                );

                                                                if (totalPages <= 1) return null;

                                                                const itemsToShow = (() => {
                                                                    const items = [];
                                                                    const total = totalPages;

                                                                    if (total <= 7) {
                                                                        for (let p = 1; p <= total; p++) items.push(p);
                                                                    } else {
                                                                        // Fixed pattern as per design:
                                                                        // 1,2,3,...,n-2,n-1,n
                                                                        items.push(1, 2, 3, '...', total - 2, total - 1, total);
                                                                    }
                                                                    return items;
                                                                })();

                                                                return (
                                                                    <div className="opportunities-table-pagination personalization-targeting-content-pagination" style={{minHeight: '55px', height: '55px'}}>
                                                                        <button
                                                                            type="button"
                                                                            className="opportunities-page-nav opportunities-page-nav-prev"
                                                                            onClick={() => setTargetingContentTablePage((p) => Math.max(1, p - 1))}
                                                                            disabled={effectivePage <= 1}
                                                                            aria-label="Previous page"
                                                                        >
                                                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M15.8334 10.0003H4.16675M4.16675 10.0003L10.0001 15.8337M4.16675 10.0003L10.0001 4.16699" stroke="#344054" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                                                            </svg>
                                                                            <span>Previous</span>
                                                                        </button>

                                                                        <nav className="d-flex align-items-center gap-1 opportunities-page-numbers" aria-label="Targeting & Content pagination">
                                                                            {itemsToShow.map((p, idx) =>
                                                                                p === '...' ? (
                                                                                    <span key={`tc-ellipsis-${idx}`} className="px-2">…</span>
                                                                                ) : (
                                                                                    <button
                                                                                        key={p}
                                                                                        type="button"
                                                                                        // className={`btn btn-sm rounded ${effectivePage === p ? 'sxi_primary_lightblue_btn' : 'opportunities-pagination-outline'}`}
                                                                                        className={`${effectivePage === p ? 'acitve-pagination' : 'pagination-outline'}`}
                                                                                        onClick={() => setTargetingContentTablePage(p)}
                                                                                        aria-label={`Page ${p}`}
                                                                                        aria-current={effectivePage === p ? 'page' : undefined}
                                                                                        style={{backgroundColor: '#F9FAFB', width: '35px', height: '35px', borderRadius: '8px'}}
                                                                                    >
                                                                                        {p}
                                                                                    </button>
                                                                                )
                                                                            )}
                                                                        </nav>

                                                                        <button
                                                                            type="button"
                                                                            className="opportunities-page-nav opportunities-page-nav-next"
                                                                            onClick={() => setTargetingContentTablePage((p) => Math.min(totalPages, p + 1))}
                                                                            disabled={effectivePage >= totalPages}
                                                                            aria-label="Next page"
                                                                        >
                                                                            <span>Next</span>
                                                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M4.16675 10.0003H15.8334M15.8334 10.0003L10.0001 4.16699M15.8334 10.0003L10.0001 15.8337" stroke="#344054" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                );
                                                            })()}
                                                        </>
                                                    ) : (
                                                        <div className="mb-3 px-4">No targeting items found</div>
                                                    )}
                                                </div>
                                            </Container>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>

                            {/* Original Publish Button Area */}
                            <div className='mx-2 mt-3'>
                                <div className="d-flex align-items-center gap-2">
                                    {publish_btn_loading ?
                                        <Button
                                            className='d-flex align-items-center justify-content-center sxi_primary_blue_btn btn-height'
                                            style={{marginBottom: '4px'}} disabled><Spinner size="sm"
                                                                                            animation="border"/></Button>
                                        :
                                        <Button
                                            className='d-flex align-items-center justify-content-center sxi_primary_blue_btn btn-height'
                                            disabled={!landingPageSelected || !campaignData?.landing_page_urls?.trim() || campaignSnapshot(campaignData) === initialSnapshotRef.current}
                                            onClick={handlePublish}>Save</Button>
                                    }
                                    <button className="back-button btn-height" onClick={handleBack}>
                                        {/* <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                                            <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
                                        </svg> */}
                                        Back
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default PersonalizationCampaign;

// Function to clean URL by removing parameters and trailing slashes
const cleanUrl = (url) => {
    if (!url) return '';
    
    try {
        // Create URL object to parse the URL
        const urlObj = new URL(url);
        
        // Get only the origin and pathname (remove query parameters, hash, etc.)
        let cleanUrl = urlObj.origin + urlObj.pathname;
        
        // Remove trailing slash if it exists
        cleanUrl = cleanUrl.replace(/\/$/, '');
        
        return cleanUrl;
    } catch (error) {
        // If URL parsing fails, try to clean manually
        let cleanUrl = url;
        
        // Remove query parameters (everything after ?)
        cleanUrl = cleanUrl.split('?')[0];
        
        // Remove hash (everything after #)
        cleanUrl = cleanUrl.split('#')[0];
        
        // Remove trailing slash
        cleanUrl = cleanUrl.replace(/\/$/, '');
        
        return cleanUrl;
    }
};

function getNameFromUrl(url) {
    try {
        const parsedUrl = new URL(url);
        let pathname = parsedUrl.pathname.replace(/\/+$/, ""); // remove trailing slash
    
        if (!pathname || pathname === "/") {
            // If no path, return domain without www and TLD
            let hostname = parsedUrl.hostname.replace(/^www\./, "");
            let name = hostname.split(".")[0]; // first part before TLD
            return name;
        }
    
        // Get last path segment
        let parts = pathname.split("/");
        let lastPart = parts.pop() || parts.pop(); // handle trailing slash
    
        // Replace underscores/dashes with spaces
        let cleanName = lastPart.replace(/[-_]/g, " ");
    
        return cleanName.trim();
    } catch (e) {
        return null;
    }
}  